import { api } from '../common/api'

export const forgotPwdSendSMS = (params: Pick<AllParams, 'usrId'>) => api.get<Pick<AllParams, 'fpId' | 'tel'>>('/customer/forgot/pwd/sms', { params })

export const forgotPwdSMSVerify = (params: Pick<AllParams, 'sms' | 'fpId'>) => api.post<null>('/customer/forgot/pwd/sms/verify', params)

export const forgotUsernameVerify = (usrId: string) => api.get<null>('/customer/forgot/pwd/acc/verify', { params: { usrId }, hideMsg: true })

export const forgotPwdUpdate = (params: Pick<AllParams, 'rnpwd' | 'npwd' | 'fpId'>) => api.post<null>('/customer/forgot/pwd/update', params)
